<template>
  <div :class="$style.container" @mouseleave="deselectTab">
    <NsTabs
      :class="$style.tabs"
      :selected="navSelected"
      :height="38"
      slider-width-to-content
      use-hover
      @select="selectTab"
    >
      <NsTab v-for="item in navigation" :key="item.name" :class="$style.tab">
        <span>{{ item.name }}</span>
        <a :href="item.href" :class="$style.tabLink"></a>
      </NsTab>
    </NsTabs>
    <nav :class="$style.tabsDropdown">
      <NsTabsItems :selected="navSelected">
        <div
          v-for="(item, index) in navigation"
          :key="index"
          :class="$style.tabItem"
        >
          <NsTopnavSection
            :navigation="JSON.stringify(item.subnav)"
            :opened="navSelected === index"
            :hide-see-all="item.hideSeeAll"
          />
        </div>
      </NsTabsItems>
    </nav>
  </div>
</template>

<script>
import { TopNavService } from "@nuskin/ns-product";
import { NsTabs, NsTab, NsTabsItems } from "@nuskin/design-components";

import NsTopnavSection from "./NsTopnavSection.vue";

export default {
  name: "NsTopnav",
  components: {
    NsTabs,
    NsTab,
    NsTabsItems,
    NsTopnavSection
  },
  data: function() {
    return {
      /**
       * Toggles display of the corresponding mega dropdown section
       * -1 unsets display
       */
      navSelected: -1,
      navigation: []
    };
  },
  watch: {
    navSelected: {
      immediate: true,
      handler() {
        document
          .querySelectorAll(".tabItem.iron-selected .tab-column__body")
          // eslint-disable-next-line arrow-parens
          .forEach(column => {
            column.style.width = `${column.scrollWidth}px`;
          });
      }
    }
  },
  mounted: function() {
    this.getNavigation();
  },
  methods: {
    deselectTab() {
      this.navSelected = -1;
    },
    selectTab(index) {
      this.navSelected = index;
    },
    async getNavigation() {
      this.navigation = await TopNavService.getNextGenAndCsTopNavigation();
    }
  }
};
</script>

<style lang="scss" module>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/global.mixins";
@use "~@nuskin/ns-core-styles/src/scss/globalVariables";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/other";

$header-column-count: 12;
$header-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);

.tabs {
  width: 100%;

  > div:first-child {
    justify-content: center;
  }
}

.tab {
  position: relative;
  flex: 0 auto;
  margin: 0 18px;
  overflow: unset;

  &:first-child {
    margin-left: 0;
  }
}

.tab span {
  @include global.nav-label();
  padding: 0;
  font-size: 15px;
  font-weight: normal;
  letter-spacing: 0;
  line-height: 18px;
  text-transform: none;
  text-align: center;
  white-space: pre-wrap;
  transition: map.get(other.$otherUtils, global-transition);
}

.tab a {
  color: map.get(colors.$themeColors, color-interactive-8);
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

/*MEGA DROPDOWN*/

.tabsDropdown {
  position: absolute;
  top: 100%;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  z-index: map.get(other.$otherUtils, z-dropdown);
  width: 100%;
  height: auto;
  max-height: 590px;
  background-color: white;
  box-shadow: $header-box-shadow;
  transition: map.get(other.$otherUtils, global-transition);
  overflow: auto;
}

.tabsDropdown::before {
  content: "";
  position: absolute;
  top: -5px;
  width: 100%;
  height: 5px;
  box-shadow: $header-box-shadow;
  z-index: 1;
}

.tabItem {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 0 auto;
}

.tabItem .tab-column__body {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  max-height: 520px;
}

.tabLink {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  width: 100%;
}

@media (max-width: 1023px) {
  .tabsDropdown {
    display: none;
  }
}

@media (min-width: 1024px) {
  .tabs {
    margin: 0px -18px -8px;
    width: calc(100% + 36px);
    height: 38px;
  }
}

@media (min-width: 1440px) {
  .tabItem {
    max-width: 1410px;
  }
}
</style>
